var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scope.row[_vm.config.prop].length != 0)?_c('img',{staticStyle:{"max-height":"60px"},attrs:{"src":`${_vm.picAPI}` + _vm.scope.row[_vm.config.prop][0].url}}):_c('span',[_vm._v("无")])
}
var staticRenderFns = []

export { render, staticRenderFns }